import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import BootstrapVueNext from 'bootstrap-vue-next'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue-next/dist/bootstrap-vue-next.css"

import i18n from './locales'

createApp(App).use(store).use(router).use(BootstrapVueNext).use(i18n).mount('#app')

